import { Link } from 'react-router-dom';
import { BarChart3, Target, ArrowRight } from 'lucide-react';
import TomoroKitLogo from '../shared/components/branding/TomoroKitLogo';

export default function HomePage() {
  const features = [
    {
      to: '/dashboard/positioning',
      icon: Target,
      title: 'Positioning',
      description: 'Compare investment approaches and positioning',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-[1400px] mx-auto px-12 py-24">
        {/* Hero */}
        <div className="text-center mb-24">
          <div className="mb-12">
            <img 
              src="/TemasekHoldings_logo.svg" 
              alt="Temasek" 
              className="h-16 mx-auto mb-8"
            />
            <div className="flex items-center justify-center gap-3 mb-8">
              <div className="h-px w-24 bg-[#291B4C]/20" />
              <div className="flex flex-col items-center gap-1 px-3 py-2 border border-[#291B4C]/10 rounded-lg">
                <span className="text-[8px] font-medium text-[#291B4C]/40 uppercase tracking-wider leading-none">
                  Powered by
                </span>
                <TomoroKitLogo 
                  className="h-3 text-[#291B4C]" 
                  style={{ '--tomoro': '#291B4C', '--kit': '#291B4C', '--kit-opacity': '0.3' } as React.CSSProperties}
                />
              </div>
              <div className="h-px w-24 bg-[#291B4C]/20" />
            </div>
          </div>
          
          <h1 className="text-6xl font-bold text-[#291B4C] mb-6 tracking-tight uppercase">
            Investment Persona
            <br />
            Analytics
          </h1>
          <p className="text-xl text-[#291B4C]/60 mb-12 max-w-2xl mx-auto tracking-wide">
            Discover your firm investment philosophy through AI-powered analysis
          </p>
          
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-3 px-10 py-4 bg-[#291B4C] text-white text-base font-semibold rounded-lg uppercase tracking-wider hover:bg-[#1a1030]"
          >
            <BarChart3 className="w-5 h-5" strokeWidth={2} />
            Launch Dashboard
            <ArrowRight className="w-5 h-5" strokeWidth={2} />
          </Link>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-3 gap-6 mb-20">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <Link
                key={feature.to}
                to={feature.to}
                className="p-8 border border-[#291B4C]/10 rounded-xl hover:border-[#291B4C]/30 bg-white"
              >
                <div className="w-14 h-14 rounded-lg bg-[#291B4C] flex items-center justify-center mb-6 text-white">
                  <Icon className="w-7 h-7" strokeWidth={2} />
                </div>
                <h3 className="text-lg font-bold text-[#291B4C] mb-2 uppercase tracking-wide">
                  {feature.title}
                </h3>
                <p className="text-sm text-[#291B4C]/60 leading-relaxed">
                  {feature.description}
                </p>
              </Link>
            );
          })}

          <Link
            to="/dashboard"
            className="p-8 bg-[#291B4C] rounded-xl text-white"
          >
            <div className="w-14 h-14 rounded-lg bg-white/10 flex items-center justify-center mb-6">
              <BarChart3 className="w-7 h-7" strokeWidth={2} />
            </div>
            <h3 className="text-lg font-bold mb-2 uppercase tracking-wide">
              Overview Dashboard
            </h3>
            <p className="text-sm text-white/80 leading-relaxed">
              See all analytics and insights in one comprehensive view
            </p>
          </Link>
        </div>

        {/* Footer */}
        <div className="text-center pt-12 border-t border-[#291B4C]/10">
          <div className="flex items-center justify-center gap-2">
            <span className="text-xs font-medium text-[#291B4C]/50 tracking-wide">
              Powered by <span className="font-semibold text-[#291B4C]/70">Temasek</span>
              {' × '}
            </span>
            <TomoroKitLogo 
              className="h-3 text-[#291B4C]" 
              style={{ '--tomoro': '#291B4C', '--kit': '#291B4C', '--kit-opacity': '0.3' } as React.CSSProperties}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
